import { render, staticRenderFns } from "./JCloudregionList.vue?vue&type=template&id=abb163f2&"
import script from "./JCloudregionList.vue?vue&type=script&lang=js&"
export * from "./JCloudregionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports